import './lynoras/style';
import FormStructure from './lynoras/form_structure';

export default FormStructure;